import { identical, path, pipe } from 'ramda';
import { PAYMENT_TYPE } from '../../../../main/payment/constants';

export const getCurrentPayment = path(['register', 'payment', 'currentPayment']);
export const getHasPaymentOpened = pipe(getCurrentPayment, Boolean);
const paymentOpened = type => pipe(
  getCurrentPayment,
  identical(type),
);
export const getIsGiftCardOpened = paymentOpened(PAYMENT_TYPE.giftCard);
